// Centralizes how a stored muscle group value is shown to the user.
// "Legs" is legacy data (the selector now offers Quadriceps/Hamstrings) and is
// expanded to "Legs (Quadriceps + Hamstrings)" so users know it covers both
// regions. The stored value stays "Legs"; only the label changes.

export const toI18nKey = (val) =>
  val
    .replace(/\s+/g, "")
    .replace(/[^a-zA-Z0-9]/g, "")
    .replace(/^[A-Z]/, (c) => c.toLowerCase());

export function getMuscleGroupLabel(value, t) {
  if (!value) return value;
  if (value === "Legs") {
    return `${t("common:muscleGroup.legs")} (${t(
      "common:muscleGroup.quadriceps"
    )} + ${t("common:muscleGroup.hamstrings")})`;
  }
  const key = `common:muscleGroup.${toI18nKey(value)}`;
  const label = t(key);
  // i18next returns the key itself when there's no translation; fall back to the
  // raw value so unknown/legacy muscle groups don't render a key string.
  return label === key ? String(value) : label;
}
